export const formatEur = (value: number): string =>
  new Intl.NumberFormat("fi-FI", { style: "currency", currency: "EUR" }).format(value);
